import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import Pill from '@/components/molecules/pill/pill';
import styles from './filter-button.module.scss';

export interface FilterButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** The class name to apply */
  className?: string;
  /** Count to show in the filter button */
  count?: number;
  /** Indicates whether the button is disabled */
  disabled?: boolean;
  /** Indicates whether the button stretches to fill its container */
  isFullWidth?: boolean;
  /** Label to show in the filter button */
  label: string;
  /** Indicates weather to show the icon */
  showIcon?: boolean;
}

const FilterButton = ({
  className,
  count,
  disabled = false,
  isFullWidth = false,
  label,
  showIcon = false,
  ...rest
}: FilterButtonProps) => {
  return (
    <button
      {...rest}
      className={classNames(styles.component, className, {
        [styles.isDisabled]: disabled,
        [styles.isFullWidth]: isFullWidth,
      })}
    >
      {showIcon && <Icon className={styles.icon} name="Filter" size={20} />}

      <Typography tag="span" tagStyle="bodyMediumBold">
        {label}
      </Typography>

      {count && <Pill count={count} variant="secondary" />}

      <Icon
        className={classNames(styles.icon, styles.isChevron)}
        name="ChevronDown"
      />
    </button>
  );
};

FilterButton.displayName = 'FilterButton';

export default FilterButton;
